import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=9ea764ce&scoped=true&"
import script from "./empty.vue?vue&type=script&lang=js&"
export * from "./empty.vue?vue&type=script&lang=js&"
import style0 from "./empty.vue?vue&type=style&index=0&id=9ea764ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.3.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea764ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/erp_Product/erp_front/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9ea764ce', component.options)
    } else {
      api.reload('9ea764ce', component.options)
    }
    module.hot.accept("./empty.vue?vue&type=template&id=9ea764ce&scoped=true&", function () {
      api.rerender('9ea764ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/directives/empty/empty.vue"
export default component.exports